export default {"src":"/uk/_next/static/media/thumbsUpIcon.266af347.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};